import { BOOKING_ACTION } from "../actions";
import * as STEP_KEYS from "../consts/stepKeys";
import { deepAssign } from "../../../utils";

const INITIAL_STATE = {
  page: "booking",
  loading: false,
  loaded: false,
  current: STEP_KEYS.SPECIALTY_TYPE,
  completedSteps: [],
  controlVisibility: {},
  reload: false
};

const toggleControl = (state, action) => {
  const { key, visible } = action.payload;
  return deepAssign(state, visible, ["controlVisibility", key]);
};

const goToStep = (state, action) => {
  const { step } = action.payload;
  return { ...state, current: step };
};

const completeStep = (state, action) => {
  const { step } = action.payload;
  if (state.completedSteps.includes(step)) return state;
  return { ...state, completedSteps: [...state.completedSteps, step] };
};

const goBackToStep = (state, action) => {
  const { steps } = action.payload;

  return { ...state, completedSteps: steps };
};

export const bookingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BOOKING_ACTION.TOGGLE_DRAWER:
      return toggleControl(state, action);

    case BOOKING_ACTION.GO_TO_STEP:
      return goToStep(state, action);

    case BOOKING_ACTION.COMPLETE_STEP:
      return completeStep(state, action);

    case BOOKING_ACTION.GO_BACK_TO_STEP:
      return goBackToStep(state, action);

    case BOOKING_ACTION.RELOAD_STEPS:
      return { ...state, reload: action.payload.reload };

    case BOOKING_ACTION.START_LOADING:
      return { ...state, loading: true };

    case BOOKING_ACTION.FINISH_LOADING:
      return { ...state, loading: false, loaded: true };

    case BOOKING_ACTION.STORE_VERIFY_CODE:
      return { ...state, verifyCode: action.payload.verifyCode };

    case BOOKING_ACTION.GO_TO_PAGE:
      return { ...state, page: action.payload.page };

    case BOOKING_ACTION.MAKE_NEW_BOOKING:
      return { ...INITIAL_STATE, loaded: true };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/bookingReducer.js